const HARDCODED_TOGGLES = {
  additionalPinsInCart: {
    value: true,
  },
  addNewAddress: {
    value: true,
  },
  attachmentsPage: {
    value: true,
  },
  attributionLinkClipboardCopy: {
    value: true,
    title: 'Copy Attributed Link',
    description: 'Associates can copy their attributed link directly from the Product Detail Page.',
  },
  autoPopulateDefaultEmailAddress: {
    value: false,
    title: 'auto populate email address as default',
    description: 'When composing a new email, Preferred email address (if selected) will auto-populate to To: field. ',
  },
  bgClickThrough: {
    value: true,
  },
  bgFarfetch: {
    value: false,
  },
  bgUcaAccountCreationFlow: {
    value: true,
  },
  clientInformationFromUca: {
    value: true,
  },
  clientOnlineBagTab: {
    value: false,
  },
  clientProfileFromConversation: {
    value: true,
  },
  clientProfileRedesign: {
    value: false,
  },
  collectionStyleboardEnabled: {
    value: true,
  },
  dclMatchDate: {
    value: false,
  },
  defaultClientEmailSearch: {
    value: false,
    title: 'client search: email as default',
    description: 'Email is the default metric for global client search',
  },
  digitalClientLead: {
    value: true,
    title: 'Digital Client Leads',
    description:
      'Associates will now see their Digital Client Leads in an automated client group, and will be notified when matched with new clients.',
  },
  disableEmailRecipientsLimit: {
    value: true,
  },
  disableUnavailableContactOptions: {
    value: true,
    title: 'Disable Email & Phone when not provided on Client Profile',
    description:
      'Send via Email & Send via SMS options will be unavailable if there is no Email Address or Phone Number provided on Client Profile',
  },
  dleReadOnly: {
    value: true,
  },
  ecidLookAndEdit: {
    value: true,
  },
  ecidSingleProductShare: {
    value: true,
  },
  editsHolidayCategory: {
    value: false,
  },
  editsStyleboardPadding: {
    value: true,
  },
  editBgTab: {
    value: true,
  },
  emailEditAttachment: {
    value: true,
    title: 'Add Edits from Email screen',
    description: 'Users can now browse and add edits from the New Email screen by pressing the + icon then "Edits"',
  },
  emailEditShareTracking: {
    value: false,
  },
  emailSupportExtendedDeliveryFailureStatuses: {
    value: false,
  },
  emailTemplateHeaderCategories: {
    value: true,
  },
  enableCustomSplitPercentages: {
    value: false,
  },
  enableGiftReceipt: {
    value: true,
    Description: 'Gift Receipt can be sent to the client. ',
    Title: 'Gift Receipt',
  },
  enableSplitGiftReceipt: {
    value: false,
  },
  expandedClientConnectsManagerView: {
    value: true,
    description: 'Managers now have visibility into their Associates Client Connects',
    title: 'Manager Visibility of Client Connects',
  },
  expandedProductReservations: {
    value: false,
  },
  expAssociateScorecardRedesign: {
    value: true,
    description: 'Associate scorecard now includes average trips per customer and average trip value.',
    title: 'Expanded Scorecard',
  },
  giftReturn: {
    value: true,
    description:
      "We've modified the gift return process. When a user selects Gift Return? option, the are required to enter PIM SKU / UPC and one (1) of the following fields: purchasing client name, phone/email, and/or shipping address zip code",
    title: 'Gift Returns',
  },
  holidayLookCategory: {
    value: false,
  },
  iceCheckout: {
    value: true,
    title: 'PRECIOUS JEWELRY CHECKOUT',
    description: 'Checking out Precious Jewelry is now available!',
  },
  instoreCheckoutRefactor: {
    value: false,
  },
  instoreExpandedPaymentOptions: {
    value: true,
  },
  instoreGiftCards: {
    value: true,
    Description: 'Gift cards can be used for MPOS transactions.',
    Title: 'Gift Card For MPOS',
  },
  managerProductReservations: {
    value: false,
  },
  maoInventory: {
    value: false,
  },
  maoMpos: {
    value: false,
  },
  maoOrders: {
    value: false,
  },
  marketingPillsCcAndGlobalSearch: {
    value: true,
    description: 'Marketing Event Pills are now visible from Global Search and the Client Connect page.',
    title: 'Marketing Event Pills on Client Connect page and Global Search',
  },
  mobilePos: {
    value: false,
  },
  myChatClientsGroup: {
    value: false,
  },
  myClientsDclGroup: {
    value: false,
  },
  myClientsDevelopingGroup: {
    value: false,
  },
  myClientsEstablishedGroup: {
    value: false,
  },
  myClientsFirstTripGroup: {
    value: false,
  },
  myClientsNmvipGroup: {
    value: false,
  },
  myClientsRelationshipGroup: {
    value: false,
  },
  myClientsTab: {
    value: false,
  },
  myClientsTabAllNmSa: {
    value: false,
  },
  myClientsTwoTripsGroup: {
    value: false,
  },
  myEditsEnhancement: {
    value: false,
  },
  newEditContent: {
    value: true,
    description:
      'New Editorial Content (Edits) available to all Connect Users. Edits can be seen in the Style Module and shared via email/text',
    title: 'Introducing Edits',
  },
  nmAppClientFilter: {
    value: true,
    description: "We've added a filter to the client list for NM App users",
    title: 'NM App Filter',
  },
  nmAssociateReservations: {
    value: false,
  },
  notificationPagination: {
    value: true,
  },
  noLimitLookShare: {
    value: true,
  },
  oneAppIconUpdate: {
    value: false,
  },
  onlineCartApiV2: {
    value: true,
  },
  orderAttribution: {
    value: true,
  },
  orderSubmitFailure: {
    value: false,
  },
  paymentSledIntegration: {
    value: false,
  },
  pdpSaleAdornment: {
    value: true,
  },
  productReservations: {
    value: false,
  },
  productShareComissionAttribution: {
    value: false,
  },
  productSpotlightLandingPage: {
    value: true,
  },
  purchaseInsights: {
    value: false,
    title: 'Customer Purchase Insights',
    description: 'Associates can now view purchase insights on customer profiles.',
  },
  refreshBgCategory: {
    value: false,
  },
  renameChatMessage: {
    value: true,
  },
  resort22LookCategory: {
    value: false,
    title: 'Resort 2022 ',
    description: 'New category of Looks is now available for Resort 2022!',
  },
  returnDate: {
    value: true,
    title: 'Return Date',
    description: 'Associates can see the date an item was returned',
  },
  saImageUpload: {
    value: false,
  },
  searchAllReservations: {
    value: false,
  },
  skuTrackerExpandedSms: {
    value: true,
    title: 'Sku Tracker Sharing Enhancements',
    description:
      'Sharing a sku tracker via SMS is now on an 1:1 associate to client basis.\n\nUsers can now also share Sku Trackers via NM App Message (with eligible clients).',
  },
  skuTrackerProductShareViaChat: {
    value: true,
    title: 'Sku Tracker via Chat',
    description: 'Users can now share Sku Trackers via Chat',
  },
  smGroupMigration: {
    value: false,
  },
  stanleyEligibleClientGroup: {
    value: false,
  },
  storeMappingAccess: {
    value: true,
  },
  storeSendsReceipts: {
    value: true,
  },
  takesLpOverride: {
    value: true,
  },
  targetedClientList: {
    value: true,
    description: "President's and Chairman's Challenge filters are now active on Client List. Expires 10/24",
    title: "President's and Chairman's Challenge",
  },
  trackingMetricsProductLookTextShare: {
    value: true,
  },
  vertexO: {
    value: false,
  },
  viewingProductReservations: {
    value: false,
  },
  voidsForOrderDetailsPage: {
    value: true,
  },
};

export default HARDCODED_TOGGLES;
